import { compose as r } from "../../../tailwind-buddy-interface.js";
const s = r({
  slots: {
    root: ["flex", "items-center"],
    content: [
      "grow",
      "flex",
      "flex-col",
      "gap-050",
      "min-w-0",
      // Forces the block to shrink when the element is full
      "px-100",
      "py-075"
    ],
    slot: "shrink-0"
  },
  variants: {
    /** Sets the component size. `cardSize` (by default) matches with the parent `Card` size. */
    size: {
      sm: {
        root: ["px-150", "py-100"]
      },
      md: {
        root: ["px-250", "py-200"]
      },
      cardSize: {
        root: [
          "group-[.sm]/card:px-150",
          "group-[.sm]/card:py-100",
          "group-[.md]/card:px-250",
          "group-[.md]/card:py-200"
        ]
      }
    }
  },
  compoundVariants: [
    {
      conditions: {
        noBorder: !1
      },
      class: {
        root: ["border-b-width-sm", "border-color-primary"]
      }
    }
  ],
  responsiveVariants: [],
  defaultVariants: {
    size: "cardSize"
  }
})();
export {
  s as cardHeaderVariants
};
